import { Container } from './styles'
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'
import telegram from '../../assets/email-download-svgrepo-com.svg'

export function Footer() {
  return (
    <Container className="footer">
      <a href="mailto:rahulmadwalkar5@gmail.com" className="logo">
        <span>Rahul R.</span>
        <span>Madawalkar</span>
      </a>
      <div>
        <p className="copyright">© {new Date().getFullYear()} Rahul R. Madawalkar — All rights reserved</p>
      </div>
      <div className="social-media">
        <a
          href="https://linkedin.com/in/0x-rahul/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a
          href="https://github.com/CryptoMaN-Rahul"
          target="_blank"
          rel="noreferrer"
          aria-label="GitHub"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=%2B918767307108&text=Hello+Rahul+I+found+your+contact+through+portfolio+site.%0A%0A"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a
          href="mailto:rahulmadwalkar5@gmail.com"
          target="_blank"
          rel="noreferrer"
          aria-label="Email"
        >
          <img src={telegram} alt="Email" />
        </a>
      </div>
    </Container>
  )
}
